import { connect } from 'react-redux';
import { changePageParams, changePage } from 'actions';
import PlayCricketMVPsPage from './PlayCricketMVPsPage';

const mapStateToProps = state => ({
    mvps: state.data.mvps,
    sort: state.data.params.sort
});

const mapDispatchToProps = dispatch => ({
    sortColumn: column => dispatch(changePageParams('sort', column)),
    browserBack: (pathname, params) => dispatch(changePage(pathname, params))
});

export default connect(mapStateToProps, mapDispatchToProps)(PlayCricketMVPsPage);




// WEBPACK FOOTER //
// ./src/views/play-cricket-mvps/index.js